import React from "react";
import './kcommonevent.css';

function CommonEvent() {
    return (
        <section id="blog-846">
            <div className="cs-container">
                <div className="cs-content">
                    <span className="cs-topper">Festivals</span>
                    <h2 className="cs-title">Celebrations</h2>
                </div>
                <ul className="cs-card-group">
                    <li className="cs-item">
                        <picture className="cs-picture">
                            <source media="(max-width: 600px)" srcSet="/images/ram-lakshman.jpg"></source>
                            <source media="(min-width: 601px)" srcSet="/images/ram-lakshman.jpg"></source>
                            <img loading="lazy" decoding="async" src="/images/ram-lakshman.jpg" alt="Ram Lakshman" width="369" height="290"></img>
                        </picture>
                        <div className="cs-item-content">
                            <h3 className="cs-h3">Ramnawami Celebrations</h3>
                            <p className="cs-item-text">
                                Physical therapy is often an important part of the recovery process for patients who have undergone surgery.
                            </p>
                            <a href="https://www.youtube.com/watch?v=Q962QJ2Ozk8" className="cs-link">
                                Read More
                                <img className="cs-icon" src="/images/orange-carrot-right.svg" alt="arrow right" width="20" height="20" loading="lazy" decoding="async" aria-hidden="true"></img>
                            </a>
                        </div>
                    </li>
                    <li className="cs-item">
                        <picture className="cs-picture">
                            <source media="(max-width: 600px)" srcSet="/images/krishna-holi.jpeg"></source>
                            <source media="(min-width: 601px)" srcSet="/images/krishna-holi.jpeg"></source>
                            <img loading="lazy" decoding="async" src="/images/krishna-holi.jpeg" alt="Krishna Holi" width="369" height="290"></img>
                        </picture>
                        <div className="cs-item-content">
                            <h3 className="cs-h3">Holi Celebration</h3>
                            <p className="cs-item-text">
                                Physical therapy is often an important part of the recovery process for patients who have undergone surgery.
                            </p>
                            <a href="https://www.youtube.com/watch?v=uotILv5WkQI" className="cs-link">
                                Read More
                                <img className="cs-icon" src="/images/orange-carrot-right.svg" alt="arrow right" width="20" height="20" loading="lazy" decoding="async" aria-hidden="true"></img>
                            </a>
                        </div>
                    </li>
                    <li className="cs-item">
                        <picture className="cs-picture">
                            <source media="(max-width: 600px)" srcSet="/images/Chaitanya-Mahabrabhu-at-Jagannath.jpg"></source>
                            <source media="(min-width: 601px)" srcSet="/images/Chaitanya-Mahabrabhu-at-Jagannath.jpg"></source>
                            <img loading="lazy" decoding="async" src="/images/Chaitanya-Mahabrabhu-at-Jagannath.jpg" alt="Rath Yatra" width="369" height="290"></img>
                        </picture>
                        <div className="cs-item-content">
                            <h3 className="cs-h3">Gouri Purnima Celebrations</h3>
                            <p className="cs-item-text">
                                Physical therapy is often an important part of the recovery process for patients who have undergone surgery.
                            </p>
                            <a href="https://www.youtube.com/watch?v=ATEU7E3c2J8" className="cs-link">
                                Read More
                                <img className="cs-icon" src="/images/orange-carrot-right.svg" alt="arrow right" width="20" height="20" loading="lazy" decoding="async" aria-hidden="true"></img>
                            </a>
                        </div>
                    </li>
                    <li className="cs-item">
                        <picture className="cs-picture">
                            <source media="(max-width: 600px)" srcSet="/images/GovardhanPuja.jpeg"></source>
                            <source media="(min-width: 601px)" srcSet="/images/GovardhanPuja.jpeg"></source>
                            <img loading="lazy" decoding="async" src="/images/GovardhanPuja.jpeg" alt="Govardhan Puja" width="369" height="290"></img>
                        </picture>
                        <div className="cs-item-content">
                            <h3 className="cs-h3">Govardhan Puja Celebrations</h3>
                            <p className="cs-item-text">
                                Physical therapy is often an important part of the recovery process for patients who have undergone surgery.
                            </p>
                            <a href="https://www.youtube.com/watch?v=ZPZqSVUc4kc" className="cs-link">
                                Read More
                                <img className="cs-icon" src="/images/orange-carrot-right.svg" alt="arrow right" width="20" height="20" loading="lazy" decoding="async" aria-hidden="true"></img>
                            </a>
                        </div>
                    </li>
                    <li className="cs-item">
                        <picture className="cs-picture">
                            <source media="(max-width: 600px)" srcSet="/images/rath-yatra-2024.jpeg"></source>
                            <source media="(min-width: 601px)" srcSet="/images/rath-yatra-2024.jpeg"></source>
                            <img loading="lazy" decoding="async" src="/images/rath-yatra-2024.jpeg" alt="Rath Yatra" width="369" height="290"></img>
                        </picture>
                        <div className="cs-item-content">
                            <h3 className="cs-h3">Jagganath Rath Yatra</h3>
                            <p className="cs-item-text">
                                Physical therapy is often an important part of the recovery process for patients who have undergone surgery.
                            </p>
                            <a href="https://youtu.be/XQe-I19TVjE" className="cs-link">
                                Read More
                                <img className="cs-icon" src="/images/orange-carrot-right.svg" alt="arrow right" width="20" height="20" loading="lazy" decoding="async" aria-hidden="true"></img>
                            </a>
                        </div>
                    </li>
                    <li className="cs-item">
                        <picture className="cs-picture">
                            <source media="(max-width: 600px)" srcSet="/images/details-lightbox.jpg"></source>
                            <source media="(min-width: 601px)" srcSet="/images/details-lightbox.jpg"></source>
                            <img loading="lazy" decoding="async" src="/images/details-lightbox.jpg" alt="Janmastami" width="369" height="290"></img>
                        </picture>
                        <div className="cs-item-content">
                            <h3 className="cs-h3">Janmastami Celebrations</h3>
                            <p className="cs-item-text">
                                Physical therapy is often an important part of the recovery process for patients who have undergone surgery.
                            </p>
                            <a href="https://www.youtube.com/watch?v=MZeTeExSyS4" className="cs-link">
                                Read More
                                <img className="cs-icon" src="/images/orange-carrot-right.svg" alt="arrow right" width="20" height="20" loading="lazy" decoding="async" aria-hidden="true"></img>
                            </a>
                        </div>
                    </li> 
                    <li className="cs-item">
                        <picture className="cs-picture">
                            <source media="(max-width: 600px)" srcSet="/images/Narasimha.jpg"></source>
                            <source media="(min-width: 601px)" srcSet="/images/Narasimha.jpg"></source>
                            <img loading="lazy" decoding="async" src="/images/Narasimha.jpg" alt="Narasimha" width="369" height="290"></img>
                        </picture>
                        <div className="cs-item-content">
                            <h3 className="cs-h3">Sri Narasimha Chaturdashi</h3>
                            <p className="cs-item-text">
                            Celebrating the appearance of Lord Narasimha, the man-lion incarnation of Lord Vishnu. Celebrated typically in May.
                            </p>
                            <a href="https://www.youtube.com/watch?v=MZeTeExSyS4" className="cs-link">
                                Read More
                                <img className="cs-icon" src="/images/orange-carrot-right.svg" alt="arrow right" width="20" height="20" loading="lazy" decoding="async" aria-hidden="true"></img>
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
        </section>       
  );
}
export default CommonEvent;

